export default "__VITE_ASSET__BcA1detD__"